import './App.css';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import UserVerify from './user_page.js';
import Landing from './landing_page.js';
import Links from './links_page.js';
import Music from './music_page.js';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} /> 
        <Route path="/land" element={<UserVerify />} />
        <Route path='/link' element={<Links/>}/>
        <Route path='/music/:password' element={<Music/>}/>
      </Routes>
    </Router>
  );
}

export default App;
